// /centers 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).
// 기존 renderCell의 switch 문을 그대로 옮긴 것으로, 미지정 값의 폴백 라벨도 동일하게 유지한다.

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 종류(kindOf) — 기존 폴백: "기타"
const kindOfMeta: Record<string, StatusMeta> = {
  Kindergarten: { label: "유치원", color: "primary" },
  ChildHouse: { label: "어린이집", color: "info" },
  Dementia: { label: "치매", color: "warning" },
  IDisabled: { label: "지적장애", color: "warning" },
};

export const resolveKindOf = (value: unknown): StatusMeta =>
  kindOfMeta[String(value)] ?? { label: "기타", color: "default" };

// 유형(estType) — 기존 폴백: "???"
const estTypeMeta: Record<string, StatusMeta> = {
  NATIONAL: { label: "국립", color: "default" },
  PUBLIC_ATTACHED: { label: "공립(병설)", color: "default" },
  PUBLIC_STANDALONE: { label: "공립(단설)", color: "default" },
  PRIVATE_CORP: { label: "사립(법인)", color: "default" },
  PRIVATE_INDIVIDUAL: { label: "사립(사인)", color: "default" },
  NATIONAL_PUBLIC: { label: "국공립", color: "default" },
  SOCIAL_WELFARE: { label: "사회복지법인", color: "default" },
  CORP_ORGS: { label: "법인·단체등", color: "default" },
  CIVIL: { label: "민간", color: "default" },
  HOME: { label: "가정", color: "default" },
  COOPERATIVE: { label: "협동", color: "default" },
  WORKPLACE: { label: "직장", color: "default" },
};

export const resolveEstType = (value: unknown): StatusMeta =>
  estTypeMeta[String(value)] ?? { label: "???", color: "default" };

// 상태(status) — 기존 폴백: "???"
const statusMeta: Record<string, StatusMeta> = {
  OPENED: { label: "정상", color: "success" },
  PAUSED: { label: "휴지", color: "warning" },
  CLOSED: { label: "폐지", color: "error" },
  REOPENED: { label: "재개", color: "primary" },
};

export const resolveStatus = (value: unknown): StatusMeta =>
  statusMeta[String(value)] ?? { label: "???", color: "default" };
